import { render, staticRenderFns } from "./Liquidacion.vue?vue&type=template&id=f32972e2"
import script from "./Liquidacion.vue?vue&type=script&lang=ts"
export * from "./Liquidacion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports